import { MenuItem } from "./dataTypes";
import { cloneDeep } from "lodash";
import pages from "../pages";

const asMenuItem = <T>(menuItems: { [K in keyof T]: { items: MenuItem[] } }) => menuItems;

const CONFIGS = asMenuItem({
  MENU: {
    items: [
      {
        label: "HOME",
        to: pages.HOME,
        id: "HOME",
      },
      /* Navbar menu*/
    ],
  },
  MENU_DRAWER: {
    items: [
      {
        label: "HOME",
        to: pages.HOME,
        id: "HOME",
      },
      /* Drawer menu*/
    ],
  },
});

export const createMenu = (conf: keyof typeof CONFIGS) => {
  const menuConfig = CONFIGS[conf];

  return cloneDeep(menuConfig.items);
};
